/* eslint-disable max-len */
// The key in the RESPONSE header that contain paging info about the data returned e.g. page number, total items, etc...
export const DATA_RANGE_HEADER_KEY = 'vnd.tinkermode.range';
/**
 * The sort order values that backend allow
 */
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
})(SortOrder || (SortOrder = {}));
/**
 * The Home member role
 */
export var MemberRole;
(function (MemberRole) {
    MemberRole["OWNER"] = "owner";
    MemberRole["MEMBER"] = "member";
})(MemberRole || (MemberRole = {}));
/** **********************************    DEVICE CONFIG SCHEME INTERFACES    ************************************* */
export var DeviceConfigParamType;
(function (DeviceConfigParamType) {
    DeviceConfigParamType["STRING"] = "string";
    DeviceConfigParamType["NUMBER"] = "number";
    DeviceConfigParamType["BOOLEAN"] = "boolean";
    DeviceConfigParamType["ARRAY"] = "array";
    DeviceConfigParamType["OBJECT"] = "object";
})(DeviceConfigParamType || (DeviceConfigParamType = {}));
/**
 * The types of smart modules that mode platform support
 */
export var SmartModuleType;
(function (SmartModuleType) {
    SmartModuleType["WEBHOOKS"] = "webhooks";
    SmartModuleType["TSDB"] = "tsdb";
    SmartModuleType["GOOGLE_ANALYTICS"] = "google_analytics";
    SmartModuleType["SDS"] = "sds";
    SmartModuleType["VIDEO"] = "video";
})(SmartModuleType || (SmartModuleType = {}));
/**
 * Aggregation function that backend can apply to the data when we fetch time series data
 */
export var TimeSeriesAggregation;
(function (TimeSeriesAggregation) {
    TimeSeriesAggregation["MIN"] = "min";
    TimeSeriesAggregation["MAX"] = "max";
    TimeSeriesAggregation["AVG"] = "avg";
    TimeSeriesAggregation["COUNT"] = "count";
    TimeSeriesAggregation["SUM"] = "sum";
})(TimeSeriesAggregation || (TimeSeriesAggregation = {}));
/**
 * The data resolution that back end uses to aggregate data
 */
export var TimeSeriesResolution;
(function (TimeSeriesResolution) {
    TimeSeriesResolution["SEC_5"] = "5sec";
    TimeSeriesResolution["SEC_15"] = "15sec";
    TimeSeriesResolution["MIN_1"] = "1min";
    TimeSeriesResolution["MIN_10"] = "10min";
    TimeSeriesResolution["HOUR_1"] = "1hour";
    TimeSeriesResolution["DAY_1"] = "1day";
    TimeSeriesResolution["WEEK_1"] = "1week";
    TimeSeriesResolution["MONTH_1"] = "1month";
})(TimeSeriesResolution || (TimeSeriesResolution = {}));
/**
 * Location type for devices, modules, etc...
 */
export var LocationType;
(function (LocationType) {
    LocationType["INDOOR"] = "indoor";
    LocationType["OUTDOOR"] = "outdoor"; // GPS
})(LocationType || (LocationType = {}));
/**
 * These are the list of error code. Note that these error code ARE NOT error code returned by the backend.
 * These are frontend error code. Sometime backend returns the same error code for many different kind of
 * error. To be able to show more descriptive error messages, we will use the backend error code + error message
 * and map them to a more specific error code.
 */
export var ApiErrorCode;
(function (ApiErrorCode) {
    // generic errors shared by multiple APIs
    ApiErrorCode["INCORRECT_PASSWORD"] = "INCORRECT_PASSWORD";
    ApiErrorCode["PASSWORD_TOO_SHORT"] = "PASSWORD_TOO_SHORT";
    ApiErrorCode["PASSWORD_TOO_WEAK"] = "PASSWORD_TOO_WEAK";
    ApiErrorCode["UNKNOWN_EMAIL"] = "UNKNOWN_EMAIL";
    ApiErrorCode["EMAIL_IN_USE"] = "EMAIL_IN_USE";
    ApiErrorCode["UNAUTHENTICATED_CLIENT"] = "UNAUTHENTICATED_CLIENT";
    ApiErrorCode["INVALID_AUTH_CODE"] = "INVALID_AUTH_CODE";
    ApiErrorCode["AUTHORIZATION_REQUIRED"] = "AUTHORIZATION_REQUIRED";
    ApiErrorCode["EXCEEDED_MAX_HOMES"] = "EXCEEDED_MAX_HOMES";
    ApiErrorCode["INVALID_PHONE_NUMBER"] = "INVALID_PHONE_NUMBER";
    ApiErrorCode["INVALID_EMAIL"] = "INVALID_EMAIL";
    ApiErrorCode["MEMBER_EXISTS"] = "MEMBER_EXISTS";
    ApiErrorCode["DEVICE_NOT_CLAIMABLE"] = "DEVICE_NOT_CLAIMABLE";
    ApiErrorCode["USER_EXISTS"] = "USER_EXISTS";
    ApiErrorCode["USER_EXISTS_UNVERIFIED"] = "USER_EXISTS_UNVERIFIED";
    ApiErrorCode["DEVICE_ALREADY_IN_HOME"] = "DEVICE_ALREADY_IN_HOME";
    ApiErrorCode["MEMBERS_ONLY"] = "MEMBERS_ONLY";
    ApiErrorCode["LAST_OWNER"] = "LAST_OWNER";
    ApiErrorCode["BLOCKING_LOG_REQUEST"] = "BLOCKING_LOG_REQUEST";
    ApiErrorCode["DEVICE_OFFLINE"] = "DEVICE_OFFLINE";
    ApiErrorCode["EMAIL_DOMAIN_DENIED"] = "EMAIL_DOMAIN_DENIED";
    ApiErrorCode["DATABASE_ERROR"] = "DATABASE_ERROR";
    ApiErrorCode["PERMISSION_DENIED"] = "PERMISSION_DENIED";
    ApiErrorCode["INSUFFICIENT_AUTH"] = "INSUFFICIENT_AUTH";
    // Ritz-specific API errors
    ApiErrorCode["ACCOUNT_OWNER_ONLY"] = "ACCOUNT_OWNER_ONLY";
    ApiErrorCode["ALREADY_VERIFIED"] = "ALREADY_VERIFIED";
    ApiErrorCode["AGENT_EXISTS"] = "AGENT_EXISTS";
    ApiErrorCode["AGENT_ONLY"] = "AGENT_ONLY";
    ApiErrorCode["AGENT_NOT_FOUND"] = "AGENT_NOT_FOUND";
    ApiErrorCode["VERIFIED_AGENT_ONLY"] = "VERIFIED_AGENT_ONLY";
    ApiErrorCode["ADMIN_AGENTS_ONLY"] = "ADMIN_AGENTS_ONLY";
    ApiErrorCode["INVALID_AGENT_ROLE"] = "INVALID_AGENT_ROLE";
    ApiErrorCode["INVALID_AGENT_ID"] = "INVALID_AGENT_ID";
    ApiErrorCode["AGENT_UNVERIFIED"] = "AGENT_UNVERIFIED";
    ApiErrorCode["INVALID_TOKEN"] = "INVALID_TOKEN";
    ApiErrorCode["PROJECT_AGENTS_ONLY"] = "PROJECT_AGENTS_ONLY";
    ApiErrorCode["LAST_AGENT"] = "LAST_AGENT";
    // ROBOT CLOUD API errors
    ApiErrorCode["MODE_API_ACCESS_DENIED"] = "MODE_API_ACCESS_DENIED";
    ApiErrorCode["INVALID_PARAMETER"] = "INVALID_PARAMETER";
    ApiErrorCode["REQUEST_STILL_OUTSTANDING"] = "REQUEST_STILL_OUTSTANDING";
    ApiErrorCode["REQUEST_INCOMPLETE"] = "REQUEST_INCOMPLETE";
    ApiErrorCode["ACTION_MISMATCH"] = "ACTION_MISMATCH";
    ApiErrorCode["UNSUPPORTED_ACTION"] = "UNSUPPORTED_ACTION";
    ApiErrorCode["INVALID_FILE_NAME"] = "INVALID_FILE_NAME";
    ApiErrorCode["RESULT_ALREADY_SET"] = "RESULT_ALREADY_SET";
    // MCRMT-specific API errors
    ApiErrorCode["CONTRACT_HAS_PROJECTS"] = "CONTRACT_HAS_PROJECTS";
    ApiErrorCode["CUSTOMER_HAS_CONTRACTS"] = "CUSTOMER_HAS_CONTRACTS";
    ApiErrorCode["END_DATE_REQUIRED"] = "END_DATE_REQUIRED";
    ApiErrorCode["INVALID_DATE_DIFF"] = "INVALID_DATE_DIFF";
    ApiErrorCode["INVALID_BILLING_TYPE"] = "INVALID_BILLING_TYPE";
    ApiErrorCode["INVALID_DAY_OF_MONTH"] = "INVALID_DAY_OF_MONTH";
    ApiErrorCode["INVALID_DATE_RANGE"] = "INVALID_DATE_RANGE";
    ApiErrorCode["OPERATOR_NOT_FOUND"] = "OPERATOR_NOT_FOUND";
    ApiErrorCode["CUSTOMER_NOT_FOUND"] = "CUSTOMER_NOT_FOUND";
    ApiErrorCode["CONTRACT_NOT_FOUND"] = "CONTRACT_NOT_FOUND";
    ApiErrorCode["TASK_NOT_FOUND"] = "TASK_NOT_FOUND";
    ApiErrorCode["BILLING_ACCOUNT_NOT_FOUND"] = "BILLING_ACCOUNT_NOT_FOUND";
    ApiErrorCode["BILL_NOT_FOUND"] = "BILL_NOT_FOUND";
    ApiErrorCode["PROJECT_NOT_FOUND"] = "PROJECT_NOT_FOUND";
    ApiErrorCode["INVALID_PROJECT_THEME"] = "INVALID_PROJECT_THEME";
    ApiErrorCode["DEVELOPER_NOT_FOUND"] = "DEVELOPER_NOT_FOUND";
    // errors reasons created by frontend
    ApiErrorCode["FORBIDDEN"] = "FORBIDDEN";
    ApiErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    ApiErrorCode["INVALID_RESPONSE"] = "INVALID_RESPONSE";
    ApiErrorCode["NOT_FOUND"] = "NOT_FOUND";
    ApiErrorCode["UNKNOWN"] = "UNKNOWN";
})(ApiErrorCode || (ApiErrorCode = {}));
/**
 * Interface for API call errors object. We will convert all API call errors into this interface
 * so it is easier to use them.
 */
export class ApiError extends Error {
    /**
     * @param code - The front end error code, not the same as the response status returned by the backend
     * @param message - The error message. This message should only be used internally to look at errors, not for displaying to agent
     */
    constructor(code, status, message, response) {
        super(message);
        this.status = status;
        this.code = code;
        this.response = response;
    }
}
/**
 * Parse the range data we get from api call response header. The value will be in this format '0-9/210'
 * 0-9 is the start and end indices of the first and last items returned
 * 210 is the total number of item
 * When there are 0 items, the header will be like this "* /0". For this case, we should return 0 for all values.
 */
export const parseDataRange = (range) => {
    if (range) {
        // We will first split the range string by / to get ['0-9', 210] and then split '0-9' by '-'
        // and then combine them into an array of 3 numbers, start, end, and total
        const [start, end, total] = range.split('/').map((part, index) => {
            if (index === 0 && part === '*') {
                return ['0', '0'];
            }
            return index === 0 ? part.split('-') : part;
        }).flat();
        // Then return the Range object with the parsed values
        return {
            start: Number(start),
            end: Number(end),
            total: Number(total),
        };
    }
    return undefined;
};
/**
 * Convert a JSON object to FormData
 * @param dataJSON
 * @returns
 */
export const createFormData = (dataJSON) => {
    const formData = new FormData();
    Object.keys(dataJSON).forEach(((key) => {
        formData.append(key, dataJSON[key]);
    }));
    return formData;
};
